import LoginByEmailPage from "pages/LoginPage/LoginByEmailPage";
import { Route, Routes } from "react-router-dom";
import PluginOutlookPage from "./PluginOutlookPage";
import TaskGradingEditInvisiblePage from './TaskGradingEditInvisiblePage';
import TaskGradingEditVisiblePage from './TaskGradingEditVisiblePage';

export default function PluginOutlookPageRouter() {
  return (
    <Routes>
      <Route path='' element={<PluginOutlookPage />} />
      <Route path='login' element={<LoginByEmailPage />} />
      <Route path='open' element={<TaskGradingEditVisiblePage />} />
      <Route path='close' element={<TaskGradingEditInvisiblePage />} />
    </Routes>
  );
}
